import {
  FeatureWithPlans,
  PlanAvailability,
  PricingData,
  PricingDataArray,
} from './feature-matrix.interface'

export function convertPricingDataToArray(
  data: PricingData,
  labels: Record<string, string>
): PricingDataArray {
  const features: FeatureWithPlans[] = []

  const featureNames = Object.keys(data.basic)

  featureNames.forEach((featureName) => {
    const feature: FeatureWithPlans = {
      key: featureName,
      plans: {
        basic: data.basic[featureName],
        // essential: data.essential[featureName],
        advanced: data.advanced[featureName],
        professional: data.professional[featureName],
        enterprise: data.enterprise[featureName],
      },
    }
    features.push(feature)
  })

  return { features, labels }
}

export function convertArrayToPricingData(features: FeatureWithPlans[]): {
  data: PricingData
} {
  const data: PricingData = {
    basic: {},
    // essential: {},
    advanced: {},
    professional: {},
    enterprise: {},
  }

  features.forEach((feature) => {
    Object.entries(feature.plans).forEach(([plan, value]) => {
      data[plan as keyof PlanAvailability][feature.key] = value
    })
  })

  return { data }
}
